// @ts-ignore
import  en from "src/assets/languages/locale-en.json";
// @ts-ignore
import ar from "../assets/languages/locale-ar.json";


export const i18nAsset = {
  'en-US': en,
  'ar-SA': ar
};
